import React, { Fragment, useEffect, useMemo, useState } from "react";
import { Button, Container } from "react-bootstrap";
import classes from "../WebsiteManagement/websiteManagement.module.css";
import Page from "../pagination/pagination";
import {
  GetServiceManagementFlightBookings,
  DownloadBookingTicket,
  DownloadBookingInvoice,
} from "../../entities/action/action";

const PAGE_SIZE = 50;

const thStyle = { padding: "10px 6px", textAlign: "left", fontSize: 12, fontWeight: 600, borderBottom: "2px solid #ccc", whiteSpace: "nowrap" };
const tdStyle = { padding: "10px 6px", fontSize: 12, borderBottom: "1px solid #eee", verticalAlign: "top" };

const formatDateTime = (isoStr) => {
  if (!isoStr) return { date: "", time: "" };
  const d = new Date(isoStr);
  if (isNaN(d.getTime())) return { date: isoStr, time: "" };
  return {
    date: `${d.getDate()}/${d.getMonth() + 1}/${d.getFullYear()}`,
    time: d.toLocaleTimeString(),
  };
};

const FlightBookings = () => {
  const [all, setAll] = useState([]);
  const [search, setSearch] = useState("");
  const [searchInput, setSearchInput] = useState("");
  const [page, setPage] = useState(1);

  useEffect(() => {
    (async () => {
      const res = await GetServiceManagementFlightBookings();
      if (res.success && res.bookings) setAll(res.bookings);
    })();
  }, []);

  useEffect(() => { setPage(1); }, [search]);

  const filtered = useMemo(() => {
    const q = search.trim().toLowerCase();
    if (!q) return all;
    return all.filter(
      (b) =>
        (b.name || "").toLowerCase().includes(q) ||
        String(b.phone || "").toLowerCase().includes(q)
    );
  }, [all, search]);

  const totalPages = Math.max(1, Math.ceil(filtered.length / PAGE_SIZE));
  const pageItems = filtered.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE);

  return (
    <Fragment>
      <Container style={{ display: "flex", justifyContent: "center", margin: "20px 0" }}>
        <form onSubmit={(e) => e.preventDefault()} style={{ display: "flex", alignItems: "stretch", width: "50vw" }}>
          <input className={classes.SearchInput} placeholder="Search by Name or Phone Number" value={searchInput}
            onChange={(e) => { setSearchInput(e.target.value); setSearch(e.target.value); }} />
          <button type="button" className={classes.SearchButton} onClick={() => setSearch(searchInput)}>Search</button>
        </form>
      </Container>
      {pageItems.length ? (
        <div style={{ overflowX: "auto" }}>
          <table style={{ width: "100%", borderCollapse: "collapse", minWidth: 1100 }}>
            <thead>
              <tr style={{ backgroundColor: "#585858", color: "#fff" }}>
                <th style={thStyle}>Booking Date & Time</th>
                <th style={thStyle}>Departure City & Airport</th>
                <th style={thStyle}>Arrival City & Airport</th>
                <th style={thStyle}>Traveller's Name & Details</th>
                <th style={thStyle}>PNR & Airline Details</th>
                <th style={thStyle}>Seat & Luggage</th>
                <th style={thStyle}>Reference ID</th>
                <th style={thStyle}>Base Amount</th>
                <th style={thStyle}>Purchase Amount</th>
                <th style={thStyle}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {pageItems.map((item) => {
                const orderDate = new Date(item?.orderDate);
                const segs = item.segments || [];
                const passengers = (item.passengers || []).map((p) => `${p.firstName || ""} ${p.lastName || ""}`.trim()).filter(Boolean).join(", ");
                return (
                  <tr key={item.bookingId} style={{ backgroundColor: "#f9f9f9" }}>
                    <td style={tdStyle}>
                      {orderDate.getDate()}/{orderDate.getMonth() + 1}/{orderDate.getFullYear()}
                      <div style={{ color: "gray" }}>{orderDate.toLocaleTimeString()}</div>
                    </td>
                    <td style={tdStyle}>
                      {segs.map((seg, i) => {
                        const dep = formatDateTime(seg.depTime);
                        return (
                          <div key={i} style={{ minHeight: 52, paddingBottom: 6, marginBottom: segs.length > 1 && i < segs.length - 1 ? 6 : 0, borderBottom: segs.length > 1 && i < segs.length - 1 ? "1px dashed #ddd" : "none" }}>
                            <div>{seg.originCityName || seg.origin || "—"} ({seg.origin || ""})</div>
                            <div style={{ color: "gray" }}>{seg.originAirportName || "—"}</div>
                            <div style={{ color: "gray" }}>{dep.date ? `${dep.date}, ${dep.time}` : "—"}</div>
                          </div>
                        );
                      })}
                      {!segs.length && "—"}
                    </td>
                    <td style={tdStyle}>
                      {segs.map((seg, i) => {
                        const arr = formatDateTime(seg.arrTime);
                        return (
                          <div key={i} style={{ minHeight: 52, paddingBottom: 6, marginBottom: segs.length > 1 && i < segs.length - 1 ? 6 : 0, borderBottom: segs.length > 1 && i < segs.length - 1 ? "1px dashed #ddd" : "none" }}>
                            <div>{seg.destinationCityName || seg.destination || "—"} ({seg.destination || ""})</div>
                            <div style={{ color: "gray" }}>{seg.destinationAirportName || "—"}</div>
                            <div style={{ color: "gray" }}>{arr.date ? `${arr.date}, ${arr.time}` : "—"}</div>
                          </div>
                        );
                      })}
                      {!segs.length && "—"}
                    </td>
                    <td style={tdStyle}>
                      <div>{item.name || "—"}</div>
                      <div style={{ color: "gray" }}>{item.phone || ""}</div>
                      <div style={{ color: "gray" }}>{item.email || ""}</div>
                      {passengers && <div style={{ color: "gray", fontSize: 11 }}>{passengers}</div>}
                    </td>
                    <td style={tdStyle}>
                      <div>{item.pnr || "—"}</div>
                      <div style={{ color: "gray" }}>
                        {(item.segments || []).map((s) => `${s.origin}→${s.destination}`).join(", ")}
                      </div>
                    </td>
                    <td style={tdStyle}>—</td>
                    <td style={tdStyle}>{item.orderId || "—"}</td>
                    <td style={tdStyle}>INR {Number(item.amount || 0) / 100}</td>
                    <td style={tdStyle}>{item.offeredFare ? `INR ${Number(item.offeredFare)}` : "—"}</td>
                    <td style={tdStyle}>
                      <Button size="sm" variant="outline-primary" style={{ fontSize: 10, marginBottom: 5, whiteSpace: "nowrap" }} onClick={() => DownloadBookingTicket(item.bookingId)}>
                        Download Ticket
                      </Button>
                      <Button size="sm" variant="outline-secondary" style={{ fontSize: 10, whiteSpace: "nowrap" }} onClick={() => DownloadBookingInvoice(item.bookingId)}>
                        Download Invoice
                      </Button>
                      <div style={{ background: "#0dcaf0", padding: 4, marginTop: 5, textAlign: "center", fontSize: 10 }}>
                        {(item?.status || "").toUpperCase()}
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      ) : (
        <p>No flights found</p>
      )}
      {totalPages > 1 && <Page count={totalPages} page={page} change={(_, v) => setPage(v)} />}
    </Fragment>
  );
};

export default FlightBookings;
